export { CovidIcon } from './covid'
